<template>

    <div class="tab-pane fade" id="modalitaPagamento" role="tabpanel" ref="tab">
        <h5 class="label-bar"><i class="ph-credit-card me-1"></i> Modalita di Pagamento
            <button class="btn btn-success btn-xs float-end" v-if="$root.hasFunzionalita('MODALITA_PAGAMENTO_CREATE') && !readonly" @click="nuovaModalitaPagamento()">
                <i class="ph-plus me-1"></i>Aggiungi
            </button>
        </h5>
        <div class="cc">
            <div class="row mb-3">
                <div class="col-12">

                    <div v-if="scostamentoPagamento != 0 && arrayModalitaPagamento.length > 0"
                        class="alert alert-warning mb-3">
                        <i class="ph-warning me-2"></i>
                        <strong>Attenzione:</strong>
                        <br>
                        <span v-if="scostamentoPagamento > 0">
                            Le modalita di pagamento (<strong>&euro; {{ formatNumber(totaleModalitaPagamento) }}</strong>)
                            superano il totale del progetto, IVA esclusa (<strong>&euro; {{ formatNumber(totaleProgetto) }}</strong>)
                            di <strong>&euro; {{ formatNumber(Math.abs(scostamentoPagamento)) }}</strong>.
                        </span>
                        <span v-else>
                            Le modalita di pagamento (<strong>&euro; {{ formatNumber(totaleModalitaPagamento) }}</strong>)
                            sono inferiori al totale del progetto, IVA esclusa (<strong>&euro; {{ formatNumber(totaleProgetto) }}</strong>)
                            di <strong>&euro; {{ formatNumber(Math.abs(scostamentoPagamento)) }}</strong>.
                        </span>
                    </div>

                    <div v-if="scostamentoPagamento == 0 && arrayModalitaPagamento.length > 0"
                        class="alert alert-success mb-3">
                        <i class="ph-check-circle me-2"></i>
                        La somma delle modalita di pagamento coincide con il totale del progetto, IVA esclusa
                        (<strong>&euro; {{ formatNumber(totaleProgetto) }}</strong>).
                    </div>

                    <p v-if="totali.TOTALE_FINALE != undefined && arrayModalitaPagamento.length > 0" class="text-muted small mb-3">
                        Totale del progetto = imponibile con fee &euro; {{ formatNumber(totali.IMPONIBILE) }}
                        <template v-if="totali.SCONTO != 0"> − sconti &euro; {{ formatNumber(totali.SCONTO) }}</template>
                        <template v-if="totali.CONS_IMPONIBILE != 0"> + consuntivo &euro; {{ formatNumber(totali.CONS_IMPONIBILE) }}</template>
                        <template v-if="totali.STORNI != 0"> − storni &euro; {{ formatNumber(Math.abs(totali.STORNI)) }}</template>.
                        <br>Ogni modalità attiva diventa un incasso in Contabilità.
                    </p>

                    <div v-if="arrayModalitaPagamento.length == 0" class="alert alert-info">
                        <i class="ph-info me-2"></i>Nessuna modalita di pagamento definita. Totale imponibile: (<strong>&euro; {{ formatNumber(totaleProgetto) }}</strong>).
                    </div>

                    <div v-else>
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover table-sm">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width: 30%">Cliente</th>
                                        <th style="width: 20%">Codice Acquisto<br>Importo</th>
                                        <th style="width: 13%">Con IVA</th>
                                        <th style="width: 20%">Note</th>
                                        <th v-if="$root.isGod" style="width: 7%" class="text-center">Attivo</th>
                                        <th style="width: 10%" class="text-center">Azioni</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="mp in paginatedModalitaPagamento.arr" :key="mp.ID_MODALITA_PAGAMENTO"
                                        :class="{ 'table-secondary text-muted': mp.FLG_ATTIVO == 0 }">
                                        <td>
                                            <strong>{{ mp.INTESTATARIO }}</strong> 
                                            <br>
                                            <span class="badge bg-light text-muted">{{ mp.TIPO_INTESTATARIO }}</span>
                                        </td>
                                        <td>
                                            <span class="badge bg-info bg-opacity-20 text-info">{{ mp.CODICE_ACQUISTO || 'N/A' }}</span>
                                            <br>
                                            <strong class="text-end">&euro; {{ formatNumber(parseFloat(mp.IMPORTO)) }}</strong>
                                        </td>
                                        <td class="text-end">
                                            &euro; {{ formatNumber(conIva(mp)) }}
                                            <br>
                                            <div class="text-muted small">{{ etichettaIva(mp.FK_ID_IVA) }}</div>
                                        </td>
                                        <td><span class="text-muted small">{{ mp.NOTE }}</span></td>
                                        <td v-if="$root.isGod" class="text-center">
                                            <ISwitch
                                                :size="'xs'"
                                                :modelValue="mp.FLG_ATTIVO"
                                                :disabled="readonly"
                                                @toggle="(val) => toggleFlgAttivo(mp, val)"
                                                title="Attivo/Disattivo"
                                            ></ISwitch>
                                        </td>
                                        <td class="text-center text-nowrap">
                                            <a href="#" v-if="mp.FLG_ATTIVO == 1 && $root.hasFunzionalita('INCASSI_READ')" class="text-info me-2" title="Vai all'incasso"
                                                @click.prevent="vaiIncasso(mp)">
                                                <i class="ph-arrow-square-out"></i>
                                            </a>
                                            <a href="#" class="text-primary me-2" v-if="$root.hasFunzionalita('MODALITA_PAGAMENTO_UPDATE') && !readonly"
                                                @click.prevent="modificaModalitaPagamento(mp)">
                                                <i class="ph-pencil"></i>
                                            </a>
                                            <a href="#" class="text-danger" v-if="$root.hasFunzionalita('MODALITA_PAGAMENTO_DELETE') && !readonly"
                                                @click.prevent="eliminaModalitaPagamento(mp)">
                                                <i class="ph-trash"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row page-bottom">
                            <div class="col-12 col-md-5 d-none d-sm-block">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2">
                                        VOCI: {{ paginatedModalitaPagamento.count }}
                                    </span>
                                    <span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2">
                                        TOTALE: &euro; {{ formatNumber(totaleModalitaPagamento) }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-9 col-md-6">
                                <div class="float-end pag-mobile">
                                    <Pagine v-model="searchPagamento.PAGINATION.PAGE_NUMBER"
                                        :numrighe="paginatedModalitaPagamento.count"
                                        :numpagine="searchPagamento.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
                                </div>
                            </div>
                            <div class="col-3 col-md-1">
                                <select class="form-select form-select-sm wmin-100 mt-2 float-end"
                                    data-placeholder="Limite" :tabindex="20"
                                    v-model="searchPagamento.PAGINATION.PAGE_SIZE"
                                    style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                    <option value="250">250</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpModalitaPagamento' + rs" role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0">
                    <h6 class="modal-title">
                        <i class="ph-credit-card me-2"></i>
                        {{ modalitaPagamentoSelezionata.ID_MODALITA_PAGAMENTO > 0 ? 'Modifica' : 'Nuova' }} Modalita di Pagamento
                    </h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Cliente <span class="text-danger">*</span></label>
                        <SelectIntestatario v-model:pg="modalitaPagamentoSelezionata.FK_ID_PERSONA_GIURIDICA" v-model:pf="modalitaPagamentoSelezionata.FK_ID_PERSONA_FISICA" :api-aziende="'shared-s2/aziende?TIPO=1'" :placeholder="'Seleziona'"></SelectIntestatario>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Codice Acquisto</label>
                        <input type="text" class="form-control form-control-sm"
                            v-model="modalitaPagamentoSelezionata.CODICE_ACQUISTO"
                            placeholder="Inserisci il codice acquisto" />
                    </div>
                    <div class="row mb-3">
                        <div class="col-6">
                            <label class="form-label fw-semibold">Importo IVA esclusa <span class="text-danger">*</span></label>
                            <div class="input-group input-group-sm">
                                <span class="input-group-text">&euro;</span>
                                <input type="number" step="0.01" class="form-control"
                                    v-model="modalitaPagamentoSelezionata.IMPORTO" placeholder="0.00" />
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="form-label fw-semibold">Codice IVA</label>
                            <select class="form-select form-select-sm" v-model="modalitaPagamentoSelezionata.FK_ID_IVA">
                                <option :value="0">— Nessuna —</option>
                                <option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}</option>
                            </select>
                        </div>
                        <div class="col-12 mt-1 small text-muted">
                            Con IVA: <strong>&euro; {{ formatNumber(conIva(modalitaPagamentoSelezionata)) }}</strong> · è l'importo dell'incasso in Contabilità
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Note</label>
                        <textarea class="form-control form-control-sm" rows="2"
                            v-model="modalitaPagamentoSelezionata.NOTE" placeholder="Note..."></textarea>
                    </div>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="ph-x me-1"></i>Annulla
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary"
                        @click="salvaModalitaPagamento(false)"
                        :disabled="!(modalitaPagamentoSelezionata.FK_ID_PERSONA_GIURIDICA > 0 || modalitaPagamentoSelezionata.FK_ID_PERSONA_FISICA > 0) || !modalitaPagamentoSelezionata.IMPORTO">
                        <i class="ph-check me-1"></i>Salva e chiudi
                    </button>
                    <button v-if="modalitaPagamentoSelezionata.ID_MODALITA_PAGAMENTO == 0"
                        type="button" class="btn btn-sm btn-primary"
                        @click="salvaModalitaPagamento(true)"
                        :disabled="!(modalitaPagamentoSelezionata.FK_ID_PERSONA_GIURIDICA > 0 || modalitaPagamentoSelezionata.FK_ID_PERSONA_FISICA > 0) || !modalitaPagamentoSelezionata.IMPORTO">
                        <i class="ph-check me-1"></i>Salva e continua
                    </button>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import SelectIntestatario from '@/components/common/SelectIntestatario.vue'
import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'

export default {
    name: 'TabModalitaPagamento',

    components: { SelectIntestatario, Pagine, ISwitch },

    props: {
        progetto: { type: Object, required: true },
        readonly: { type: Boolean, default: false }
    },

    data() {
        return {
            filters: global.filters,
            rs: utils.generateRandomString(30),
            arrayModalitaPagamento: [],
            totali: {},
            modalitaPagamentoSelezionata: {
                ID_MODALITA_PAGAMENTO: 0,
                FK_ID_PROGETTO: 0,
                FK_ID_PERSONA_GIURIDICA: 0,
                FK_ID_PERSONA_FISICA: 0,
                CODICE_ACQUISTO: '',
                IMPORTO: 0,
                FK_ID_IVA: 0,
                NOTE: ''
            },
            searchPagamento: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
            }
        }
    },

    computed: {
        paginatedModalitaPagamento() {
            var arr = utils.inGrid(this.arrayModalitaPagamento, this.searchPagamento);
            return arr;
        },

        // Solo le attive: sono quelle che diventano incassi
        totaleModalitaPagamento() {
            return utils.array.sumByField(this.arrayModalitaPagamento.filter(mp => mp.FLG_ATTIVO == 1), 'IMPORTO')
        },
        totaleProgetto() {
            return parseFloat(this.totali.TOTALE_FINALE) || 0
        },
        scostamentoPagamento() {
            return Math.round((this.totaleModalitaPagamento - this.totaleProgetto) * 100) / 100
        }
    },

    methods: {
        // Il tab vive dentro il modale della scheda progetto: prima lo si chiude (sfondo e lock), poi si cambia pagina
        vaiIncasso(mp) {
            const vai = () => this.$router.push({ path: '/Incassi', query: { ORIGINE_TIPO: 'MODALITA', ORIGINE_ID: mp.ID_MODALITA_PAGAMENTO } });
            const modale = this.$refs.tab.closest('.modal');
            if (!modale) return vai();
            modale.addEventListener('hidden.bs.modal', vai, { once: true });
            this.filters.closePopUp(modale.id);
        },
        formatNumber(n) {
            return utils.formatNumber(n);
        },

        // L'importo della modalità è IVA esclusa: l'incasso vale importo + IVA (stesso calcolo delle fatture)
        conIva(mp) {
            const importo = parseFloat(mp.IMPORTO) || 0;
            return importo + this.filters.ivaSuImponibile(importo, mp.FK_ID_IVA);
        },

        etichettaIva(idIva) {
            const codice = this.filters.getIvaCodeById(parseInt(idIva));
            return codice ? codice.CUSTOM_1 : 'Nessuna IVA';
        },

        load() {
            this.getModalitaPagamento()
            this.getTotali()
        },

        getModalitaPagamento() {
            if (this.progetto.ID_PROGETTO <= 0) {
                return
            }
            utils.get('theb/modalita_pagamento/progetto', { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                if (response.esito == 0) {
                    this.arrayModalitaPagamento = response.data
                }
            })
        },

        // Totale finale del progetto come nel budget: fee, sconti, storni e consuntivo compresi
        getTotali() {
            if (this.progetto.ID_PROGETTO <= 0) {
                return
            }
            utils.get('theb/modalita_pagamento/totale', { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                if (response.esito == 0) {
                    this.totali = response.data
                }
            })
        },

        // Il cliente proposto è l'intestatario del progetto
        modalitaVuota() {
            return { ID_MODALITA_PAGAMENTO: 0, FK_ID_PROGETTO: this.progetto.ID_PROGETTO, FK_ID_PERSONA_GIURIDICA: this.progetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA || 0, FK_ID_PERSONA_FISICA: this.progetto.INTESTATARIO_FK_ID_PERSONA_FISICA || 0, FK_ID_IVA: 0 }
        },

        nuovaModalitaPagamento() {
            this.modalitaPagamentoSelezionata = this.modalitaVuota()
            this.filters.openPopUp('popUpModalitaPagamento' + this.rs)
        },

        modificaModalitaPagamento(mp) {
            this.modalitaPagamentoSelezionata = utils.clone(mp);
            this.modalitaPagamentoSelezionata.FK_ID_IVA = parseInt(mp.FK_ID_IVA) || 0;
            this.filters.openPopUp('popUpModalitaPagamento' + this.rs)
        },

        salvaModalitaPagamento(continua = false) {
            if (!(this.modalitaPagamentoSelezionata.FK_ID_PERSONA_GIURIDICA > 0) && !(this.modalitaPagamentoSelezionata.FK_ID_PERSONA_FISICA > 0)) {
                utils.alert.warning('Seleziona un cliente')
                return
            }
            if (!this.modalitaPagamentoSelezionata.IMPORTO || parseFloat(this.modalitaPagamentoSelezionata.IMPORTO) <= 0) {
                utils.alert.warning('Inserisci un importo valido')
                return
            }
            var isUpdate = this.modalitaPagamentoSelezionata.ID_MODALITA_PAGAMENTO > 0
            var api = isUpdate ? 'theb/modalita_pagamento/update' : 'theb/modalita_pagamento/insert'
            var chiamata = isUpdate ? utils.put : utils.post
            chiamata(api, this.modalitaPagamentoSelezionata, (response) => {
                if (response.esito == 0) {
                    utils.alert.success('Modalita di pagamento salvata')
                    this.getModalitaPagamento()
                    if (continua) {
                        this.modalitaPagamentoSelezionata = this.modalitaVuota()
                    } else {
                        this.filters.closePopUp('popUpModalitaPagamento' + this.rs)
                    }
                } else {
                    utils.alert.danger(response.messaggio || 'Errore nel salvataggio')
                }
            })
        },

        eliminaModalitaPagamento(mp) {
            const isGod = this.$root.isGod;
            const confirmMsg = isGod
                ? 'Eliminare DEFINITIVAMENTE questa modalità di pagamento? Questa azione è irreversibile.'
                : 'Sicuro di voler elimnare questa modalità di pagamento?';
            const apiEndpoint = isGod ? 'theb/modalita_pagamento/harddelete' : 'theb/modalita_pagamento/delete';
            const successMsg = isGod ? 'Modalità di pagamento eliminata definitivamente.' : 'Modalità di pagamento eliminata con successo.';

            utils.alert.confirm(confirmMsg, () => {
                utils.delete(apiEndpoint,
                    { ID_MODALITA_PAGAMENTO: mp.ID_MODALITA_PAGAMENTO }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(successMsg)
                        this.getModalitaPagamento()
                    }
                })
            },this.$root)
        },

        toggleFlgAttivo(mp, newValue) {
            utils.put('theb/modalita_pagamento/update', {
                ID_MODALITA_PAGAMENTO: mp.ID_MODALITA_PAGAMENTO,
                FLG_ATTIVO: newValue
            }, (response) => {
                if (response.esito == 0) {
                    this.getModalitaPagamento()
                }
            })
        }
    }
}
</script>
